export default "__VITE_ASSET__BCwq9XRg__"